import React, { useEffect, useState } from 'react';
import { PlaceSelector } from './placeSelector';

const classNames = ['one', 'two', 'three']
export const PlacesSelector = ({ targets = [], regions = '', type= 'REGIONAL',onChange,onChangeSelection }) => {
  const [selection, setSelection] = useState({});
  const [lastSelection, setLastSelection] = useState({});

  useEffect(() => {
    onChange && onChange(Object.values(selection));
  }, [selection]);
  useEffect(() => {
    console.log(lastSelection)
    onChangeSelection && onChangeSelection(Object.values(lastSelection));
  }, [lastSelection]);

  return targets.map((target,i) => (
    <PlaceSelector
      key={target.ineId+target.name}
      ineId={target.ineId}
      position={i+1}
      grid={ 'bottom-space '+classNames[targets.length-1]}
      type={type}
      regions={regions}
      onChange={(obj) => {
        setSelection(obj ? ({...selection, [i]: obj}) : [])        
      }}      
      lastSelection={(obj) => {
        setLastSelection(obj ? ({...lastSelection, [i]: obj}) : [])        
      }}
    ></PlaceSelector>
  ));
};
